/* eslint-disable */

import moment from "moment";
import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import Popover from "@material-ui/core/Popover";
import { Typography } from "@material-ui/core";
// import ViewDayIcon from "@material-ui/icons/ViewDay";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import "./index.css";
import axios from "axios";

var settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: false,
};

const markHighLight = (str, keyword) => {
  const patt = new RegExp(keyword, "g");
  if (str != "" && str !== null && str !== undefined && keyword !== "") {
    return str.replace(patt, `<mark>${keyword}</mark>`);
  } else if (keyword !== "" && (str === null || str === undefined)) {
    return "";
  } else if (keyword === "" && (str === null || str === undefined)) {
    return "";
  } else if (keyword === "") {
    return str;
  }
};

const MarkItem = ({ mark, language, labels, search }) => {
  const {
    tmNameLabel,
    // categoryLabel,
    serviceCategoryLabel,
    rOrgLabel,
    rNumberLabel,
    rDateLabel,
    newLabel,
    markDescLabel,
  } = labels;
  // console.log("serviceCategoryLabel ", serviceCategoryLabel);

  const array = ["Kp", "En", "Cn", "Ru"];
  const videoRef = useRef();

  const newDate = moment(mark.createdAt).add(7, "days").format("YYYY-MM-DD");
  const today = moment().format("YYYY-MM-DD");
  const [anchorKindEl, setAnchorKindEl] = useState(null);
  const [anchorOrgEl, setAnchorOrgEl] = useState(null);
  const [anchorRegNoEl, setAnchorRegNoEl] = useState(null);
  const [anchorDescEl, setAnchorDescEl] = useState(null);
  const [anchorImageEl, setAnchorImageEl] = useState(null);
  const [anchorRegDateEl, setAnchorRegDateEl] = useState(null);

  const handleKindPopoverOpen = (event) => {
    setAnchorKindEl(event.currentTarget);
  };

  const handleKindPopoverClose = () => {
    setAnchorKindEl(null);
  };

  const openKind = Boolean(anchorKindEl);

  const handleOrgPopoverOpen = (event) => {
    setAnchorOrgEl(event.currentTarget);
  };

  const handleOrgPopoverClose = () => {
    setAnchorOrgEl(null);
  };

  const openOrg = Boolean(anchorOrgEl);
  const handleRegNoPopoverOpen = (event) => {
    setAnchorRegNoEl(event.currentTarget);
  };

  const handleRegNoPopoverClose = () => {
    setAnchorRegNoEl(null);
  };

  const openRegNo = Boolean(anchorRegNoEl);

  const handleDescPopoverOpen = (event) => {
    setAnchorDescEl(event.currentTarget);
  };

  const handleDescPopoverClose = () => {
    setAnchorDescEl(null);
  };

  const openDesc = Boolean(anchorDescEl);

  const handleImagePopoverOpen = (event) => {
    setAnchorImageEl(event.currentTarget);
  };

  const handleImagePopoverClose = () => {
    setAnchorImageEl(null);
  };

  const openImage = Boolean(anchorImageEl);

  const handleRegDatePopoverOpen = (event) => {
    setAnchorRegDateEl(event.currentTarget);
  };

  const handleRegDatePopoverClose = () => {
    setAnchorRegDateEl(null);
  };

  const openRegDate = Boolean(anchorRegDateEl);

  useEffect(() => {
    setTimeout(() => {
      $(`#video_${mark.regNo}`).on("hidden.bs.modal", () => {
        videoRef.current.pause();
      });
    }, 300);
  }, []);

  return (
    <>
      <div
        className="bg-light p-3 m-1 mark-item position-relative"
        style={{ marginTop: "32px" }}
      >
        {today <= newDate && (
          <div className="item-new-label">{newLabel[language]}</div>
        )}
        <div
          className="d-flex justify-content-center my-3"
          onMouseEnter={handleImagePopoverOpen}
          onMouseLeave={handleImagePopoverClose}
        >
          <img
            className="mark-logo"
            // data-toggle="modal"
            // data-target={`#myModal_${mark.regNo}`}
            src={`uploads/trademark/${mark.imageUrl}`}
            alt="dprk trademark"
          />
          <Popover
            id="mouse-over-popover"
            // className={classes.popover}
            // classes={{
            //   paper: classes.paper,
            // }}
            style={{ pointerEvents: "none", padding: 8 }}
            open={openImage}
            anchorEl={anchorImageEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            onClose={handleImagePopoverClose}
            disableRestoreFocus
          >
            <img
              className="mark-modal-logo"
              src={`uploads/trademark/${mark.imageUrl}`}
              alt="dprk trademark"
            />
            {/* <Typography></Typography> */}
            {/* <Typography
              // className="mark-name"
              style={{ width: 350, hight: 400 }}
              dangerouslySetInnerHTML={{
                __html: mark[`kind${array[language]}`],
              }}
            > */}
            {/* {mark(mark[`markName${array[language]}`], search)} */}
            {/* </Typography> */}
          </Popover>
        </div>
        <div className="h6 font-weight-bold position-relative">
          {tmNameLabel[language]} :{" "}
          <span
            className="mark-name"
            dangerouslySetInnerHTML={{
              __html: markHighLight(mark[`markName${array[language]}`], search),
            }}
          ></span>
        </div>
        <div className="show-details">
          <div
            className="h6 trademark-value-ellipsis"
            onMouseEnter={handleKindPopoverOpen}
            onMouseLeave={handleKindPopoverClose}
          >
            <b>{serviceCategoryLabel[language]}</b> :{" "}
            <span
              className="mark-attribute"
              dangerouslySetInnerHTML={{
                __html: mark[`kind${array[language]}`],
              }}
            >
              {/* {mark.kind} */}
            </span>
            <Popover
              id="mouse-over-popover"
              // className={classes.popover}
              // classes={{
              //   paper: classes.paper,
              // }}
              style={{ pointerEvents: "none", padding: 8 }}
              open={openKind}
              anchorEl={anchorKindEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              onClose={handleKindPopoverClose}
              disableRestoreFocus
            >
              {/* <Typography></Typography> */}
              <Typography
                // className="mark-name"
                style={{ width: 350, hight: 400 }}
                dangerouslySetInnerHTML={{
                  __html: mark[`kind${array[language]}`],
                }}
              >
                {/* {mark(mark[`markName${array[language]}`], search)} */}
              </Typography>
            </Popover>
          </div>
          <div
            className="h6 trademark-value-ellipsis"
            onMouseEnter={handleOrgPopoverOpen}
            onMouseLeave={handleOrgPopoverClose}
          >
            <b>{rOrgLabel[language]}</b> :{" "}
            <span
              className="mark-attribute"
              dangerouslySetInnerHTML={{
                __html: markHighLight(
                  mark[`ownerName${array[language]}`],
                  search
                ),
              }}
            >
              {/* {mark[`ownerName${array[language]}`]} */}
            </span>
            <Popover
              id="mouse-over-popover"
              // className={classes.popover}
              // classes={{
              //   paper: classes.paper,
              // }}
              style={{ pointerEvents: "none", padding: 8 }}
              open={openOrg}
              anchorEl={anchorOrgEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              onClose={handleKindPopoverClose}
              disableRestoreFocus
            >
              <Typography
                // className="mark-name"
                style={{ width: 350, hight: 400 }}
                dangerouslySetInnerHTML={{
                  __html: markHighLight(
                    mark[`ownerName${array[language]}`],
                    search
                  ),
                }}
              >
                {/* {mark(mark[`markName${array[language]}`], search)} */}
              </Typography>
            </Popover>
          </div>
          <div
            className="h6 trademark-value-ellipsis"
            onMouseEnter={handleRegNoPopoverOpen}
            onMouseLeave={handleRegNoPopoverClose}
          >
            <b>{rNumberLabel[language]}</b> :{" "}
            <span
              className="mark-attribute"
              dangerouslySetInnerHTML={{
                __html: markHighLight(mark.regNo, search),
              }}
            >
              {/* {mark.regNo} */}
            </span>
            <Popover
              id="mouse-over-popover"
              // className={classes.popover}
              // classes={{
              //   paper: classes.paper,
              // }}
              style={{ pointerEvents: "none", padding: 8 }}
              open={openRegNo}
              anchorEl={anchorRegNoEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              onClose={handleRegNoPopoverClose}
              disableRestoreFocus
            >
              {/* <Typography></Typography> */}
              <Typography
                // className="mark-name"
                style={{ width: 350, hight: 400 }}
                dangerouslySetInnerHTML={{
                  __html: markHighLight(mark.regNo, search),
                }}
              >
                {/* {mark(mark[`markName${array[language]}`], search)} */}
              </Typography>
            </Popover>
          </div>
          <div
            className="h6 trademark-value-ellipsis"
            onMouseEnter={handleRegDatePopoverOpen}
            onMouseLeave={handleRegDatePopoverClose}
          >
            <b>{rDateLabel[language]}</b> :{" "}
            <span className="mark-attribute">
              {moment(mark.regDate).format("YYYY-MM-DD")}
            </span>
            <Popover
              id="mouse-over-popover"
              // className={classes.popover}
              // classes={{
              //   paper: classes.paper,
              // }}
              style={{ pointerEvents: "none", padding: 8 }}
              open={openRegDate}
              anchorEl={anchorRegDateEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              onClose={handleRegDatePopoverClose}
              disableRestoreFocus
            >
              {/* <Typography></Typography> */}
              <Typography
                // className="mark-name"
                style={{ width: 350, hight: 400 }}
                dangerouslySetInnerHTML={{
                  __html: markHighLight(
                    moment(mark.regDate).format("YYYY-MM-DD"),
                    search
                  ),
                }}
              >
                {/* {mark(mark[`markName${array[language]}`], search)} */}
              </Typography>
            </Popover>
          </div>
          <div
            className="h6 trademark-value-ellipsis"
            onMouseEnter={handleDescPopoverOpen}
            onMouseLeave={handleDescPopoverClose}
          >
            <b>{markDescLabel[language]}</b> :{" "}
            <span
              className="mark-attribute"
              dangerouslySetInnerHTML={{
                __html: mark[`desc${array[language]}`],
              }}
            >
              {/* {moment(mark.regDate).format("YYYY-MM-DD")} */}
            </span>
            <Popover
              id="mouse-over-popover"
              // className={classes.popover}
              // classes={{
              //   paper: classes.paper,
              // }}
              style={{ pointerEvents: "none", padding: 8 }}
              open={openDesc}
              anchorEl={anchorDescEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              onClose={handleRegNoPopoverClose}
              disableRestoreFocus
            >
              {/* <Typography></Typography> */}
              <Typography
                // className="mark-name"
                style={{ width: 350, hight: 400 }}
                dangerouslySetInnerHTML={{
                  __html: mark[`desc${array[language]}`],
                }}
              >
                {/* {mark(mark[`markName${array[language]}`], search)} */}
              </Typography>
            </Popover>
          </div>
        </div>
        <div className="d-flex justify-content-center mt-4">
          {mark.goods && mark.goods.length > 0 && (
            <span
              className="font-weight-normal pointer videoUrl"
              data-toggle="modal"
              data-target={`#myModal_${mark.regNo}`}
              style={{
                marginRight: mark.videoUrl && mark.videoUrl != "null" ? 32 : 0,
              }}
            >
              <ImportContactsIcon
                fontSize="large"
                onClick={() => {
                  // videoRef.current.play();
                  axios
                    .post(`/api/log`, {
                      title: mark.markNameKp,
                      lang: array[language],
                      type: "화상",
                    })
                    .then((res) => {
                      // setMarks(res.data);
                      // console.log(res.data);
                    })
                    .catch();
                }}
              ></ImportContactsIcon>
            </span>
          )}
          {mark.videoUrl && mark.videoUrl != "null" && (
            <span
              className="font-weight-normal pointer videoUrl"
              data-toggle="modal"
              data-target={`#video_${mark.regNo}`}
              onClick={() => {
                videoRef.current.play();
                axios
                  .post(`/api/log`, {
                    title: mark.markNameKp,
                    lang: array[language],
                    type: "동영상",
                  })
                  .then((res) => {
                    // setMarks(res.data);
                    // console.log(res.data);
                  })
                  .catch();
              }}
            >
              <PlayCircleOutlineIcon fontSize="large"></PlayCircleOutlineIcon>
            </span>
          )}
        </div>
      </div>

      <div className="modal fade" id={`myModal_${mark.regNo}`}>
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <img
                style={{ height: 50, textAlign: "left" }}
                src={`uploads/trademark/${mark.imageUrl}`}
                alt="trademark"
              />
              {/* <div className="h5 font-weight-bold">
                {tmNameLabel[language]} :{" "}
                <span className="mark-name">
                  {mark[`markName${array[language]}`]}
                </span>
              </div> */}
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
            </div>
            <div className="modal-body" style={{ textAlign: "center" }}>
              {mark.goods.length != 0 ? (
                <Slider {...settings}>
                  {mark.goods.map((good, index) => (
                    <img
                      style={{ width: 500, textAlign: "center" }}
                      className="h-100"
                      key={index}
                      src={`uploads/good/${good.imageUrl}`}
                      alt="trademark"
                    />
                  ))}{" "}
                </Slider>
              ) : (
                <img
                  style={{ width: 500, textAlign: "center" }}
                  className="h-100"
                  src={`uploads/trademark/${mark.imageUrl}`}
                  alt="trademark"
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {mark.videoUrl && mark.videoUrl != "null" && (
        <div className="modal fade" id={`video_${mark.regNo}`}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <video width="100%" controls ref={videoRef}>
                <source
                  src={`uploads/trademark/${mark.videoUrl}`}
                  type="video/mp4"
                />
                Your browser does not support HTML5 video.
              </video>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

MarkItem.propTypes = {
  mark: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  language: state.profile.language,
  labels: state.labels,
  search: state.profile.search,
});

export default connect(mapStateToProps)(MarkItem);
